import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Cash Pluss"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-cash-plus',
    templateUrl: './icon-cash-plus.component.html',
    styleUrls: ['./icon-cash-plus.component.scss'],
    standalone: false
})
export class IconCashPlusComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
